export default __webpack_public_path__ + "static/media/Feature2(2).0abce34a.png";